import mixpanel from 'mixpanel-browser';
import { mixpanelEvents, PLATFORMS } from './constants';

const PENDING_PLATFORM_AUTH_KEY = 'pending_platform_auth';

// The error the Tray/Bagy auth callback answers with when it is called without the
// authorization parameters (TRAY_EMPTY_API_ADDRESS on the API).
const TRAY_CALLBACK_WITHOUT_PARAMS_ERROR = '3003';

/**
 * Nuvemshop and Wix do not call us back when the merchant cancels the authorization,
 * so the intent is marked before the redirect and read again when he lands back on
 * the panel: a pending authorization with no success parameters is a cancellation.
 * On the session storage because the mark only has to survive the round trip made
 * by the tab that started it.
 */
export const storePendingPlatformAuth = (platformId, authUrl) => {
    sessionStorage.setItem(
        PENDING_PLATFORM_AUTH_KEY,
        JSON.stringify({ platformId, authUrl, startedAt: Date.now() })
    );
}

export const getPendingPlatformAuth = () => {
    const stored = sessionStorage.getItem(PENDING_PLATFORM_AUTH_KEY);

    if (!stored) {
        return null;
    }

    try {
        return JSON.parse(stored);
    } catch (e) {
        return null;
    }
}

export const clearPendingPlatformAuth = () => {
    sessionStorage.removeItem(PENDING_PLATFORM_AUTH_KEY);
}

/**
 * Tray sends the merchant who had to sign in to its admin back to the auth callback
 * without any parameter, skipping the authorization. He is signed in by then, so the
 * authorization is opened once more. Returns TRUE when the authorization is retried.
 */
export const retryPendingTrayCompatibleAuth = error => {
    const pending = getPendingPlatformAuth();

    if (
        error !== TRAY_CALLBACK_WITHOUT_PARAMS_ERROR ||
        ![PLATFORMS.TRAY, PLATFORMS.BAGY].includes(pending?.platformId) ||
        !pending?.authUrl ||
        pending?.retried
    ) {
        return false;
    }

    sessionStorage.setItem(
        PENDING_PLATFORM_AUTH_KEY,
        JSON.stringify({ ...pending, retried: true })
    );

    window.location.replace(pending.authUrl);

    return true;
}

export const trackPlatformAuthFailure = ({ platformId, failureReason }) => {
    const pending = getPendingPlatformAuth();

    clearPendingPlatformAuth();

    mixpanel.track(mixpanelEvents.ONBOARDING_PLATFORM_AUTH_FAILED, {
        'platform_id': platformId || pending?.platformId,
        ...(failureReason && { 'reason': failureReason })
    })
}
